<template>
  <select-item :validator="validator"
    :items="formattedItems"
    placeholder="Select an Account Manager"
    placeholderEmpty="No account managers found"
    :isLoading="isLoading" />
</template>

<script>
import SelectItem from './SelectItem.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'SelectAccountManager',
  components: {
    SelectItem
  },
  props: {
    validator: Object
  },
  data() {
    return {
      isLoading: false
    }
  },
  created() {
    if (!this.accountManagers) {
      this.fetchAccountManagers();
    }
  },
  methods: {
    async fetchAccountManagers() {
      this.isLoading = true;
      await this.$store.dispatch('user/fetchAccountManagers');
      this.isLoading = false;
    }
  },
  computed: {
    ...mapGetters('user', ['accountManagers']),
    formattedItems() {
      if (this.accountManagers) {
        let items = this.accountManagers.map((manager) => {
          return {
            id: manager.id,
            name: manager.full_name
          };
        })
        items.unshift({ id: null, name: "No account manager" });
        return items;
      }
      return null;
    }
  }
}
</script>

